module.exports = __webpack_public_path__ + "img/temp-banner-privacy.208d3a6d.jpg";